export const allColors = ['#276EF1', '#E11900', '#FFC043', '#05944F'];

export const lighterColors: { [key: string]: string } = {
  '#276EF1': 'rgba(39, 110, 241, 0.40)',
  '#E11900': 'rgba(240, 24, 0, 0.40)',
  '#FFC043': 'rgba(255, 192, 66, 0.40)',
  '#05944F': 'rgba(5, 148, 79, 0.40)',
};
